export class ErrorEntity {
  private statusCode: number;
  private code: string;
  private type: string;
  private details: string;
  private title: string;
  private subTitle: string;

  constructor(statusCode: number, code: string, type: string, details: string, title: string, subTitle: string) {
    this.statusCode = statusCode;
    this.code = code
    this.type = type;
    this.details = details;
    this.title = title;
    this.subTitle = subTitle;
  }

  // Getters
  public getStatusCode(): number {
    return this.statusCode;
  }

  public getCode(): string {
    return this.code
  }

  public getType(): string {
    return this.type;
  }

  public getDetails(): string {
    return this.details;
  }

  public getTitle(): string {
    return this.title;
  }

  public getSubTitle(): string {
    return this.subTitle;
  }

  // Setters
  public setStatusCode(statusCode: number): void {
    this.statusCode = statusCode;
  }

  public setCode(code: string): void {
    this.code = code;
  }

  public setType(type: string): void {
    this.type = type;
  }

  public setDetails(details: string): void {
    this.details = details;
  }

  public setTitle(title: string): void {
    this.title = title;
  }

  public setSubTitle(subTitle: string): void {
    this.subTitle = subTitle;
  }
}
